module.exports = __webpack_public_path__ + "img/rouxel.269b6c26.webp";